import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../shared/confirm-dialog/confirm-dialog.component';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { MatPaginator } from '@angular/material/paginator';
import { StorageserviceService } from '../../core/services/storageservice.service';
import { AddCalendarDialogComponent } from './add-calendar-dialog/add-calendar-dialog.component';
import { AuthService } from '../../core/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { DataService } from 'src/app/core/services/data.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { CalendarEvent, CalendarView, CalendarWeekViewBeforeRenderEvent } from 'angular-calendar';
import { DatePipe } from '@angular/common';
import { addDays, differenceInMinutes, startOfDay, startOfHour, subDays, subWeeks } from 'date-fns';
import { reduce, Subject } from 'rxjs';
import { ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'app-calendar',
    templateUrl: './calendar.component.html',
    styleUrls: ['./calendar.component.css'],
    standalone: false
})
export class CalendarComponent implements OnInit {
  calendarDates: any[] = [];
  currentMonthYear: any;
  modules: any[] = ['Month', 'Week', 'Day'];
  selectedModule = 'Month';
  currentDate = new Date(); // Mutable for navigation
  selectedDate = new Date();
   hours = [
    '12 AM', '1 AM', '2 AM', '3 AM', '4 AM', '5 AM', '6 AM', '7 AM', '8 AM', '9 AM','10 AM', '11 AM', '12 PM',
    '1 PM', '2 PM', '3 PM', '4 PM', '5 PM', '6 PM','7 PM', '8 PM', '9 PM', '10 PM', '11 PM'
  ];
  hoursDay = Array.from({ length: 24 }, (_, i) => {
  const hour = i;
  return hour === 0 ? '12 AM'
       : hour < 12 ? `${hour} AM`
       : hour === 12 ? '12 PM'
       : `${hour - 12} PM`;
});

  // hours = Array.from({ length: 24 }, (_, i) => i); // 0 to 23
  // hoursDay = Array.from({ length: 12 }, (_, i) => {
  //   const hour = i + 9;
  //   return hour < 12 ? `${hour} AM` : hour === 12 ? '12 PM' : `${hour - 12} PM`;
  // });

  dayEvents: any[] = [];
  allEvents: any[] = [];
  allDayEvents: any[] = [];
  startHour = 0;
  hourHeight = 60;  //92.3
  currentTimePosition = 0;   // px from top
  currentTime = new Date();


  constructor(
    private dialog: MatDialog,private datePipe: DatePipe,
    private sanitizer: DomSanitizer, private cdr: ChangeDetectorRef,
    private storageService: StorageserviceService,
    private fb: FormBuilder, private auth: AuthService, private data: DataService, private router: Router, private toastr: ToastrService,
  ) { }

  ngOnInit() {
    //console.log('hoursDay',this.hoursDay)
   
    this.generateCalendar();
    this.initializeCalendar();

    // this.updateCurrentTimePosition();
    // setInterval(() => this.updateCurrentTimePosition(), 60 * 1000); // update every minute
  }

  updateDayCurrentTimePosition() {
    const now = new Date();
    const totalMinutes = now.getHours() * 60 + now.getMinutes();
    this.currentTimePosition = (totalMinutes / 60) * this.hourHeight;

    this.cdr.detectChanges();
  }

  updateWeekCurrentTimePosition() {
    const now = new Date();
    // console.log('Now:', now);
    // console.log('Now Hours:', now.getHours());
    // console.log('Now Minutes:', now.getMinutes());  
    // console.log('H * M',now.getHours() * 60)
    const minutesSinceMidnight = now.getHours() * 92 + now.getMinutes();
    // console.log('minutesSinceMidnight:', minutesSinceMidnight);
    // console.log("minutesSinceMidnight / 60",minutesSinceMidnight / 60)
    // console.log('hourhgt:', this.hourHeight);
    this.currentTimePosition = (minutesSinceMidnight / 60) * this.hourHeight;
    //console.log('Current Time Position:', this.currentTimePosition);
    this.cdr.detectChanges(); // ensure view updates
  }//timeline updates

  getCalendarEvents(view: 'Month' | 'Week' | 'Day') {
    //console.log('view', view)
    const off = new Date().getTimezoneOffset();
    const offset = Math.abs(off); 
    // console.log('offset', offset)
    
    let filter = '';
    const date = new Date(this.currentDate);

    if (view === 'Month') {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      filter = `M-${year}-${month}`;
    } else if (view === 'Week') {
      const startOfWeek = new Date(date.setDate(date.getDate() - date.getDay()));
      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6);

      const start = startOfWeek.toISOString().split('T')[0];
      const end = endOfWeek.toISOString().split('T')[0];
      filter = `W-${start}_${end}`;
    } else if (view === 'Day') {
      const formattedDate = date.toISOString().split('T')[0];
      filter = `D-${formattedDate}`;
    }

    // console.log('offset', offset)
    // console.log('filter', filter)

    this.auth.getEvents(offset, filter).subscribe((res: any) => {
      if (view === 'Day') {
       // this.dayEvents = res?.data.events;
       // console.log('dayEv', this.dayEvents)

      this.allDayEvents = res?.data.events.filter((e: any) => e.allday === true);

       // Inside getCalendarEvents
        this.dayEvents = res.data?.events
          .filter((e: any) => e.allday === false) // <== this line ensures no all-day events leak into time grid
          .map((event: any) => {
            const start = new Date(event.from_ts);
            const end = new Date(event.to_ts);
            const startHour = start.getHours();
            const startMinute = start.getMinutes();
            const duration = (end.getTime() - start.getTime()) / (1000 * 60 * 60);
            return { ...event, startHour, startMinute, duration };
          });
                  
        // decorate with columns + width
        this.dayEvents = this.assignEventPositions( this.dayEvents);
      } 
      else {
        this.allEvents = res?.data.events;
       // console.log('allDay', this.allEvents)
      }
    });
  }

  onModuleChange() {
    //console.log('selectedModule',this.selectedModule)

    if (this.selectedModule === 'Week') {
      this.generateWeekView();
      this.updateWeekCurrentTimePosition();
      setInterval(() => this.updateWeekCurrentTimePosition(), 60 * 1000); // update every minute
    } 
    else if (this.selectedModule === 'Day') {
      this.selectedDate = new Date(this.currentDate);
      this.updateDayCurrentTimePosition();
      setInterval(() => this.updateDayCurrentTimePosition(), 60 * 1000); // update every minute
    } 
    else {
      this.generateCalendar(); // Month view
    }

    this.getCalendarEvents(this.selectedModule as 'Month' | 'Week' | 'Day');
    this.goToToday();
  }

  generateWeekView() {
    const today = new Date(this.currentDate);
    const startOfWeek = new Date(today.setDate(today.getDate() - today.getDay())); // Sunday

    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);

    //this.currentMonthYear = `${startOfWeek.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} - ${endOfWeek.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}`;

    const startStr = startOfWeek.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    const endStr = endOfWeek.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    const yearStr = endOfWeek.getFullYear();
    this.currentMonthYear = `${startStr} - ${endStr}, ${yearStr}`;


    this.calendarDates = [];

    for (let i = 0; i < 7; i++) {
      const date = new Date(startOfWeek);
      date.setDate(startOfWeek.getDate() + i);

      this.calendarDates.push({
        day: date.getDate(),
        fullDate: new Date(date) ,
        isToday:
          date.getDate() === new Date().getDate() &&
          date.getMonth() === new Date().getMonth() &&
          date.getFullYear() === new Date().getFullYear()
      });
    }
  }

  generateCalendar() {
    const today = new Date();
    const currentMonth = this.currentDate.getMonth();
    const currentYear = this.currentDate.getFullYear();

    this.currentMonthYear = `${this.getMonthName(currentMonth)} ${currentYear}`;

    this.calendarDates = [];

    const firstDayOfMonth = new Date(currentYear, currentMonth, 1);
    const startDay = firstDayOfMonth.getDay(); // Sunday = 0
    const startDate = new Date(currentYear, currentMonth, 1 - startDay);

    for (let i = 0; i < 42; i++) {
      const date = new Date(startDate);
      date.setDate(startDate.getDate() + i);
      this.calendarDates.push({
        day: date.getDate(),
        otherMonth: date.getMonth() !== currentMonth,
        fullDate: new Date(date) ,
        isToday:
          date.getDate() === today.getDate() &&
          date.getMonth() === today.getMonth() &&
          date.getFullYear() === today.getFullYear()
      });
    }
  }

  initializeCalendar() {
    if (this.selectedModule === 'Month') {
      this.generateCalendar();
      this.getCalendarEvents('Month');
    } else if (this.selectedModule === 'Week') {
      this.generateWeekView();
      this.getCalendarEvents('Week');
    } else if (this.selectedModule === 'Day') {
      this.selectedDate = new Date(this.currentDate);
      this.getCalendarEvents('Day');
    }
  }

  changeMonth(offset: number) {
    this.currentDate.setMonth(this.currentDate.getMonth() + offset);
    this.generateCalendar();
  }

isWeekend(date: Date): boolean {
  const day = new Date(date).getDay(); // 0 = Sunday, 6 = Saturday
  return day === 0 || day === 6;
}

isSaturday(date: Date): boolean {
  return new Date(date).getDay() === 6;
}

isSunday(date: Date): boolean {
  return new Date(date).getDay() === 0;
}

  goToToday() {
    this.currentDate = new Date();
    this.selectedDate = new Date(this.currentDate);

    if (this.selectedModule === 'Month') {
      this.generateCalendar();
    } else if (this.selectedModule === 'Week') {
      this.generateWeekView();
    } else if (this.selectedModule === 'Day') {
      this.selectedDate = new Date(); // reset to today
    }

    this.getCalendarEvents(this.selectedModule as 'Month' | 'Week' | 'Day');
  }

  getMonthName(monthIndex: number): string {
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return monthNames[monthIndex];
  }

  // getEventStyle(event: any): { [key: string]: string } {
  //   return {
  //     top: (event.startHour - 0) * 60 + 'px',
  //     height: (event.duration * 60) + 'px'
  //   };
  // }

  // get currentTimePosition(): number {
  //   const now = new Date();
  //   const hour = now.getHours() + now.getMinutes() / 60;
  //   //return (hour - 9) * 60;
  //   return (hour - this.startHour) * this.hourHeight;
  // }

  navigate(offset: number) {
    if (this.selectedModule === 'Month') {
      this.currentDate.setMonth(this.currentDate.getMonth() + offset);
      this.generateCalendar();
    } else if (this.selectedModule === 'Week') {
      this.currentDate.setDate(this.currentDate.getDate() + offset * 7);
      this.generateWeekView();
    } else if (this.selectedModule === 'Day') {
      this.currentDate.setDate(this.currentDate.getDate() + offset);
      this.selectedDate = new Date(this.currentDate);
    }

    this.getCalendarEvents(this.selectedModule as 'Month' | 'Week' | 'Day');
  }

  onAddCalendar(): void {
    const dialogRef = this.dialog.open(AddCalendarDialogComponent, {
      width: '800px',
      height: '700px',
      //disableClose: true,
      panelClass: 'custom-dialog-container'
      // data: { existingCategories: this.documentCategories }
    });

    dialogRef.afterClosed().subscribe(result => {

      // if (result) {
        this.initializeCalendar();
        this.getCalendarEvents(this.selectedModule as 'Month' | 'Week' | 'Day');
      // }
    });
  }

  onEditCalendar(event: any): void {
  //console.log('event', event)
  // const offset = new Date().getTimezoneOffset();
  const offset = Math.abs(new Date().getTimezoneOffset());
  //console.log('Offset:', offset);
  //     const timezoneOffset = selectedTimezoneObj?.offset ?? 0;
  //   const notification = this.notificationItems.map((item: any) => `${item.time}-${item.unit}`);
  // console.log('Notification:', notification);

  this.auth.getSpecEvent(event.id, offset).subscribe((res: any) => {
    const eventDetails = res.data?.event;

    const dialogRef = this.dialog.open(AddCalendarDialogComponent, {
      width: '600px',
      height: '600px',
      disableClose: true,
     // panelClass: 'custom-dialog-container',
      data: { event: eventDetails }  // pass the full event data
    });

    dialogRef.afterClosed().subscribe(result => {
      this.initializeCalendar(); // Refresh all views
      this.getCalendarEvents(this.selectedModule as 'Month' | 'Week' | 'Day');
    });
  });
  }

  formatHour(timeStr: any): any {
    const [hour, minute] = timeStr.split(':');
    return `${parseInt(hour)}:00`; // Match your hours array format like "9:00", "10:00"
  }

  formatDate(date: any): any {
    return date.toISOString().split('T')[0];
  }

  formatTime(ts: any): any {
    const d = new Date(ts);
    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }  
  
  // getMonthEvents(date: Date): any[] {
  //   return this.allEvents.filter(event => {
  //     const eventDateUTC = new Date(event.from_ts);
  //     const eventLocal = new Date(eventDateUTC.getTime() - (eventDateUTC.getTimezoneOffset() * 60000));
  //     return eventLocal.toDateString() === date.toDateString();
  //   });
  // }  

  // getMonthEvents(date: Date): any[] {
  //   return this.allEvents.filter(event => {
  //     if (event.allday) return false;
  //     const eventDateUTC = new Date(event.from_ts);
  //     const eventLocal = new Date(eventDateUTC.getTime() - (eventDateUTC.getTimezoneOffset() * 60000));

  //     return eventLocal.toDateString() === date.toDateString();
  //   });
  // }

  getMonthEvents(date: Date): any[] {
    return this.allEvents.filter(event => {
      if (event.allday) return false;

      const eventDateLocal = new Date(event.from_ts); // Parsed directly
      return eventDateLocal.toDateString() === date.toDateString();
    });
  }

  convertTo24Hour(hour: string): number {
    const [time, modifier] = hour.split(' ');
    let [h] = time.split(':');
    let hourNum = parseInt(h);
  
    if (modifier === 'PM' && hourNum !== 12) {
      hourNum += 12;
    }
    if (modifier === 'AM' && hourNum === 12) {
      hourNum = 0;
    }
    return hourNum;
  }

  // getWeekEvents(date: Date, hour: any): any[] {
  //   const hourNumber = this.convertTo24Hour(hour);

  //   return this.allEvents.filter(event => {
  //     const eventStart = new Date(event.from_ts);

  //     return (
  //       !event.allday && // Exclude all-day events
  //       eventStart.toDateString() === date.toDateString() &&
  //       eventStart.getHours() === hourNumber
  //     );
  //   });
  // }

  getAllDayEvents(date: Date): any[] {
    return this.allEvents.filter(event => {
      const eventDate = new Date(event.from_ts).toDateString();
      return event.allday && new Date(date).toDateString() === eventDate;
    });
  }

  prepareEvents(events: any[]) {
    return events
      .filter(e => !e.allday)
      .map(event => {
        const start = new Date(event.from_ts);
        const end = new Date(event.to_ts);
        const startHour = start.getHours();
        const startMinute = start.getMinutes();
        const duration = (end.getTime() - start.getTime()) / (1000 * 60 * 60);

        return { ...event, startHour, startMinute, duration };
      });
  }

  getDayEvents(): any[] {
    return this.allEvents
      .filter(e => {
        const eventDate = new Date(e.from_ts);
        return !e.allday && eventDate.toDateString() === this.selectedDate.toDateString();
      })
      .map(event => {
        const start = new Date(event.from_ts);
        const end = new Date(event.to_ts);
        const startHour = start.getHours();
        const startMinute = start.getMinutes();
        const duration = (end.getTime() - start.getTime()) / (1000 * 60 * 60);

        return { ...event, startHour, startMinute, duration };
      });
  }

  // getEventStyle(event: any): { [key: string]: string } {
  //   const top =
  //     event.startHour * this.hourHeight +
  //     (event.startMinute / 60) * this.hourHeight;

  //   return {
  //     position: 'absolute',
  //     top: top + 'px',
  //     height: event.duration * this.hourHeight + 'px',
  //     left: '2px',
  //     right: '2px'
  //   };
  // }
  

getEventStyle(event: any): { [key: string]: string } {
  const top = (event.startHour * this.hourHeight) + (event.startMinute / 60) * this.hourHeight;
  const height = Math.max(event.duration * this.hourHeight, 12); // min height
  return {
    top: Math.round(top) + 'px',
    height: Math.round(height) + 'px',
    position: 'absolute'
    // left/right handled by CSS; you can add width/left if you implement overlap logic later
  };
}


getWeekEvents(date: Date, hour: any): any[] {
  const hourNumber = this.convertTo24Hour(hour);

  const events = this.allEvents.filter(event => {
    const eventStart = new Date(event.from_ts);
    return (
      !event.allday &&
      eventStart.toDateString() === date.toDateString() &&
      eventStart.getHours() === hourNumber
    );
  });

  // Assign positions for overlapping events
  return this.assignEventPositions(events);
}

// private assignEventPositions(events: any[]): any[] {
//   if (events.length <= 1) return events.map(e => ({ ...e, column: 0, width: 100 }));

//   let columns: any[][] = []; // group overlaps
//   events.forEach(event => {
//     let placed = false;
//     for (let col of columns) {
//       if (!this.isOverlapping(event, col[col.length - 1])) {
//         col.push(event);
//         placed = true;
//         break;
//       }
//     }
//     if (!placed) columns.push([event]);
//   });

//   // Assign width & column index
//   const totalCols = columns.length;
//   return events.map(event => {
//     let colIndex = columns.findIndex(col => col.includes(event));
//     return {
//       ...event,
//       column: colIndex,
//       width: 100 / totalCols
//     };
//   });
// }

assignEventPositions(events: any[]): any[] {
  // Sort by start time
  const sorted = [...events].sort((a, b) => new Date(a.from_ts).getTime() - new Date(b.from_ts).getTime());

  const result: any[] = [];
  let group: any[] = [];

  const flushGroup = () => {
    if (group.length === 0) return;
    // assign columns for group
    const cols = group.length;
    group.forEach((ev, idx) => {
      ev.column = idx;
      ev.width = 98 / cols; // each slice
    });
    result.push(...group);
    group = [];
  };

  for (let ev of sorted) {
    // compute start and end as numbers
    const start = new Date(ev.from_ts).getTime();
    const end = new Date(ev.to_ts).getTime();

    // if group empty, push
    if (group.length === 0) {
      group.push(ev);
      continue;
    }

    // check overlap with any in group
    const lastEnd = Math.max(...group.map(g => new Date(g.to_ts).getTime()));

    if (start < lastEnd) {
      // overlaps with group
      group.push(ev);
    } else {
      // no overlap with current group → flush
      flushGroup();
      group.push(ev);
    }
  }

  // flush last group
  flushGroup();

  // For any single-event group, width automatically becomes 100/1=100
  return result;
}

getEventOffset(event: any): number {
  const start = new Date(event.from_ts);
  return (start.getMinutes() / 60) * 60; // px offset within the hour
}

getEventHeight(event: any): number { // for week-event bg height
  const start = new Date(event.from_ts);
  const end = new Date(event.to_ts);
  const diffMinutes = (end.getTime() - start.getTime()) / (1000 * 60);
  return (diffMinutes / 60) * 60 + 20; // px height
}

private isOverlapping(eventA: any, eventB: any): boolean {
  const startA = new Date(eventA.from_ts).getTime();
  const endA = new Date(eventA.to_ts).getTime();
  const startB = new Date(eventB.from_ts).getTime();
  const endB = new Date(eventB.to_ts).getTime();
  return startA < endB && startB < endA; // overlap check
}

}